import { trans } from "@mongez/localization";

export function ContactUsLocation() {
  const googleMap =
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14294.724395791854!2d50.136945!3d26.4014886!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49e5278d0c28ef%3A0xeba119cf80525bef!2z2KfZhNiy2KfZhdmEINmE2YTZhdmD2YrZgdin2KogWmFtaWwgQWlyIENvbmRpdGlvbmVycw!5e0!3m2!1sen!2seg!4v1759565910474!5m2!1sen!2seg";

  return (
    <iframe
      title={trans("location")}
      src={googleMap}
      width="100%"
      className="h-[200px] md:h-[300px] lg:h-[480px] ltr:rounded-l-[44px] rtl:rounded-r-[44px]"
    />
  );
}
